<template>
  <div class="episode-header">
    <div class="container">
      <section class="grid xs:py-0 m:py-16">
        <div class="block mt-6 mb-6 episode-header__image grid__el--xs-12 m:hidden">
          <div class="rounded">
            <book-cover :sources="episode.coverImageSources" :alt="altText" />
          </div>
        </div>

        <div class="grid__el--xs-12 grid__el--m-7 grid__el--l-8">
          <episode-info
            :episode-title="episode.title"
            :shortcast-title="shortcast.title"
            :shortcast-tagline="shortcast.tagline"
            :episode-description="episode.description"
          />

          <div class="episode-header__stats">
            <episode-stats :duration="episode.duration" />
          </div>
        </div>

        <div class="hidden episode-header__image grid__el--xs-12 grid__el--m-5 grid__el--l-4 m:block">
          <book-cover :sources="episode.coverImageSources" :alt="altText" />
        </div>

        <episode-player-wrapper
          class="episode-header__player grid__el--xs-12 grid__el--m-7 grid__el--l-8"
          :episode="episode"
        >
          <audio-player :audio-url="episode.audioUrl" :shortcast="shortcast" :episode="episode" />
        </episode-player-wrapper>

        <shortcast-description
          :shortcast-title="shortcast.title"
          :shortcast-description="shortcast.about"
          class="episode-header__description grid__el--xs-12 grid__el--l-8"
        />
      </section>
    </div>
  </div>
</template>

<script>
import EpisodeInfo from "./episode-info"
import EpisodeStats from "./episode-stats"
import ShortcastDescription from "./shortcast-description"
import EpisodePlayerWrapper from "./episode-player-wrapper"
import BookCover from "@/shared/book-cover"
import AudioPlayer from "../audio-player"

export default {
  name: "EpisodeHeader",
  components: {
    EpisodeInfo,
    EpisodeStats,
    BookCover,
    ShortcastDescription,
    EpisodePlayerWrapper,
    AudioPlayer
  },
  props: {
    shortcast: {
      type: Object,
      required: true
    },
    episode: {
      type: Object,
      required: true
    }
  },
  computed: {
    altText() {
      return this.$t("altText", {
        showTitle: this.shortcast.title,
        episodeNumber: this.episode.episodeNumber,
        episodeTitle: this.episode.title,
        tagline: this.shortcast.tagline
      })
    }
  },
  i18n: {
    messages: {
      en: {
        altText: 'Shortcast episode cover of "{showTitle}", episode {episodeNumber} {episodeTitle} {tagline}'
      },
      de: {
        altText: 'Shortcast-Episoden-Cover von "{showTitle}", Episode {episodeNumber} {episodeTitle}, {tagline}'
      }
    }
  }
}
</script>

<style lang="scss">
.episode-header {
  background: $pale-mint-grey;

  &__get-key-ideas {
    margin-bottom: $spacing-32;

    color: $mid-grey;

    font-weight: bold;
  }

  &__stats {
    width: 100%;
    margin-bottom: $spacing-48;
  }

  &__player {
    margin-bottom: $spacing-48;
  }

  &__image {
    grid-row-end: span 2;
  }
}
</style>
